export default "__VITE_ASSET__BeJnpD_i__"